// Screen↔image coordinate utilities. Spec §7.2, §7.3.
//
// Image→screen is handled implicitly by the SVG `viewBox` in OverlaySvg.
// For screen→image we rely on the SVG element's own post-transform
// bounding rect: because react-zoom-pan-pinch's CSS transform sits above
// the SVG, `getBoundingClientRect()` already encodes zoom + pan + any
// preserveAspectRatio fitting. Mapping is then a plain rect ratio, which
// stays correct whether the user is zoomed in, panned, or at rest.

export type ImageSize = readonly [number, number]; // [H, W]

export function screenToImage(
  clientX: number,
  clientY: number,
  svgRect: DOMRect,
  imageSize: ImageSize
): [number, number] {
  const [h, w] = imageSize;
  if (svgRect.width <= 0 || svgRect.height <= 0 || h <= 0 || w <= 0) {
    return [0, 0];
  }
  const u = ((clientX - svgRect.left) / svgRect.width) * w;
  const v = ((clientY - svgRect.top) / svgRect.height) * h;
  const cu = Math.min(Math.max(u, 0), w - 1);
  const cv = Math.min(Math.max(v, 0), h - 1);
  return [cu, cv];
}
